import {Component, OnInit} from '@angular/core';
import {ButtonClassesEnum, IButtonModel,} from '@types-custom/models/ui/button-model';
import {Icon} from '@types-custom/models/ui/icon-model';
import {ODMatrizService} from "@shared/services/odmatriz-service/odmatriz.service";
import {ODMatrixFilteredTypesEnum} from "@shared/models/ODMatrix/ODMatrix.model";

@Component({
  selector: 'cdm-almeria-map-filter-matrix-od',
  templateUrl: './map-filter-matrix-od.component.html',
  styleUrls: ['./map-filter-matrix-od.component.scss'],
})

export class MapFilterMatrixODComponent implements OnInit{
  Icon=Icon;
  buttonTag = 'BUSCAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes : IButtonModel = {};

  firstFilter       : string = 'origin'
  percentageFilters : string[] = ['Todos']

  SelectedFilterOptions : any[] = []


  ngOnInit(): void {
    this.generateButtonAttributes();
    this.generateRangeOfPercentageButtons();
  }

  constructor(
    private ODMatrixService : ODMatrizService
  ) {
  }

  private generateButtonAttributes(): void {
    this.restorebuttonAttributes = {
      label: 'RESTABLECER',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.transparent_button_2_custom,
      },
    };
    this.applybuttonAttributes = {
      label: 'APLICAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter_custom,
      },
    };
  }
  private generateRangeOfPercentageButtons() {

    this.SelectedFilterOptions = [
      "00% - 10%",
      "41% - 50%",
      "81% - 90%",
      "11% - 20%",
      "51% - 60%",
      "91% - 100%",
      "21% - 30%",
      "61% - 70%",
      "Todos",
      "31% - 40%",
      "71% - 80%",
    ]

    this.reloadData();
  }

  public selectPercentage(id : string) {
    if(id === 'Todos' || (this.percentageFilters.length >= (this.SelectedFilterOptions.length - 1)) ) {
      this.selectAllPercentages();
    }
    else {
      if(document.getElementById('Todos').classList.contains('active')) {
        document.getElementById('Todos').classList.remove('active')
        this.percentageFilters.splice(this.percentageFilters.indexOf('Todos'),1)
      }

      let item = document.getElementById(id);

      if (item.classList.contains('active')) {
        item.classList.remove('active')
        this.percentageFilters.splice(this.percentageFilters.indexOf(id),1)
      }
      else {
        item.classList.add('active')
        this.percentageFilters.push(id)
      }
    }
  }

  private selectAllPercentages() {
    this.percentageFilters.forEach((e) => {
      document.getElementById((e)).classList.remove('active')
    })

    let item = document.getElementById('Todos')

    if (item.classList.contains('active')) {
      item.classList.remove('active')
      this.percentageFilters = []
    }
    else {
      item.classList.add('active')
      this.percentageFilters = ['Todos']
    }
  }

  public selectTypeMatrix(id : string) {
    (id === 'origin') ? this.removeClass('destination') : this.removeClass('origin')
    document.getElementById(id).classList.add('active')
    this.firstFilter = id
  }
  private removeClass(id : string) {
    document.getElementById(id).classList.contains('active') ?
      document.getElementById(id).classList.remove('active') :
      null
  }

  public sendValues(type : boolean) {
    if(type) {
      this.percentageFilters = ['Todos']
      this.selectTypeMatrix('origin')
    }

    document.querySelector<HTMLElement>('#Matriz').click();

    (type) ? document.querySelector<HTMLElement>('#Matriz').parentElement.classList.remove('applied-filter') :
             document.querySelector<HTMLElement>('#Matriz').parentElement.classList.add('applied-filter');

    this.ODMatrixService.sensorFilterSubject.next(
      {
              type : ODMatrixFilteredTypesEnum.MATRIX,
              values : {
                direction : this.firstFilter,
                percentage : this.percentageFilters
              }
            }
    )
  }

  private reloadData() {
    this.ODMatrixService.filteredSensor$.subscribe((res : any) => {
      if(res?.type === ODMatrixFilteredTypesEnum.MATRIX) {
        this.percentageFilters = res.values.percentage
        this.firstFilter = res.values.direction
        this.selectTypeMatrix(this.firstFilter)
      }
    })
  }

  ExitsOnArray(item: any) {
    return (this.percentageFilters.find((e) => {return e === item}))
  }
}
